






























































































import { createComponent, ref, onMounted, watch, reactive } from '@vue/composition-api'
import { UnwrapRef } from '@vue/composition-api/dist/reactivity'
import { getFileIcon, formatFileSize } from '../helpers/common'
import { IFileItem, getRecycleDir, reduceRecycle, RecycleFileItem } from '@/service/public'
import { Message, Table, Input, MessageBox } from 'element-ui'

interface FormType {
    deleteTime?: string[]
    fileName?: string
}
interface ConditType {
    pageNum: number
    pageSize: number
    total: number
}

export default createComponent({
    setup() {
        const tableRef = ref<Table>(void null)
        const sortBy = ref<string>('ascending')
        const formInline: UnwrapRef<FormType> = reactive({
            deleteTime: [],
            fileName: '',
        })
        const conditions: UnwrapRef<ConditType> = reactive({
            pageNum: 1,
            pageSize: 10,
            total: 0,
        })
        const tableData = ref<RecycleFileItem[]>([])
        const contextmenu = reactive({
            show: false,
            position: {
                x: 0,
                y: 0,
            },
        })
        const rowContextItem = ref<IFileItem>({})
        enum SortBy {
            ascending = 1,
            descending = -1,
        }
        const getRecycleDirs = async (current?: number) => {
            let params = {
                name: formInline.fileName,
                startTime: formInline.deleteTime && formInline.deleteTime[0],
                endTime: formInline.deleteTime && formInline.deleteTime[1],
                current: current || conditions.pageNum,
                size: conditions.pageSize,
                sortNum: SortBy[sortBy.value],
            }
            let res = await getRecycleDir(params)
            if (res.code === 0) {
                const pageInfo = res.data.pageInfo
                tableData.value = pageInfo.list
                conditions.pageNum = pageInfo.pageNum
                conditions.pageSize = pageInfo.pageSize
                conditions.total = pageInfo.total
            } else {
                Message.error(res.desc || '查询失败')
            }
        }
        const changePageSize = (pageSize: number) => {
            conditions.pageSize = pageSize
            getRecycleDirs()
        }
        const setCurrentPage = (currentPage: number) => {
            conditions.pageNum = currentPage
            getRecycleDirs()
        }
        const rowClick = (row: IFileItem) => {
            contextmenu.show = false
        }
        const rowContextMenu = (row: IFileItem, column: any, event: MouseEvent) => {
            rowContextItem.value = row
            event.preventDefault()
            tableRef.value.setCurrentRow(row)
            // store.commit("publicStore/SET_RIGHT_MENU_IS_SHOW", true)
            // 计算坐标是否超出屏幕所在位置
            const windowHeight = document.body.clientHeight
            const windowWidth = document.body.clientWidth
            const clickClientY = event.clientY
            const clickClientX = event.clientX
            // const offsetY = windowHeight - clickClientY > 216 + 20 ? 0 : 216 + 20 - (windowHeight - clickClientY)
            const offsetY = 0
            const offsetX = windowWidth - clickClientX > 100 ? 0 : 100 - (windowWidth - clickClientX)
            contextmenu.position.x = event.pageX - offsetX
            contextmenu.position.y = event.pageY - offsetY
            contextmenu.show = true
        }

        const isReduce = ref<boolean>(false)
        const cacheIds = ref<string[]>([])
        const reduceList = async (ids: string[]) => {
            if (isReduce.value) return
            isReduce.value = true
            const res = await reduceRecycle({ ids })
            isReduce.value = false

            if (res.code === 0) {
                Message.success(res.desc || '还原成功')
                getRecycleDirs()
            } else {
                Message.error(res.desc || '还原失败')
            }
        }
        const handleSelect = () => {
            contextmenu.show = false
            if (!rowContextItem.value || cacheIds.value.includes(rowContextItem.value.id)) return
            cacheIds.value = [rowContextItem.value.id]
            reduceList(cacheIds.value)
        }
        const selectFiles = ref<IFileItem[]>([])

        const HandleSelectTableChange = val => {
            if (val && val.length) {
                selectFiles.value = val.filter(item => item.id !== 'createNewDir')
            } else {
                selectFiles.value = []
            }
        }
        const reduceIds = () => {
            const ids = selectFiles.value.map(item => {
                return item.id
            })
            reduceList(ids)
        }
        const sortChange = ({ order }) => {
            if (order) {
                sortBy.value = order
            }
            getRecycleDirs()
        }
        onMounted(async () => {
            await getRecycleDirs()
        })
        return {
            tableRef,
            formInline,
            conditions,
            tableData,
            getFileIcon,
            changePageSize,
            setCurrentPage,
            contextmenu,
            rowContextMenu,
            rowClick,
            handleSelect,
            HandleSelectTableChange,
            getRecycleDirs,
            reduceIds,
            selectFiles,
            sortChange,
            formatFileSize,
            isReduce,
        }
    },
})
